export const faqsPl = [
  {
    q: "Ile kosztuje aplikacja Flutter na Android i iOS?",
    a: "Proste MVP Flutter (logowanie, kilka ekranów, podstawowy backend) zaczyna się zwykle od kilkudziesięciu tysięcy złotych. Aplikacja z panelem admina, powiadomieniami i integracjami to najczęściej zakres od ok. 80 000 do 250 000+ zł — zależnie od złożoności. Dajemy orientacyjną wycenę po rozmowie o zakresie.",
  },
  {
    q: "Co obejmuje audyt aplikacji Flutter?",
    a: "Sprawdzamy jakość kodu, stabilność, architekturę, dług techniczny, zależności, buildy iOS/Android oraz gotowość do dalszego utrzymania. Po audycie dostajesz raport z ryzykami i rekomendacjami — często przed przejęciem projektu po innym wykonawcy.",
  },
  {
    q: "Czy możecie przejąć istniejącą aplikację Flutter?",
    a: "Tak. Typowa ścieżka: NDA, audyt repozytorium, wycena utrzymania i dalszego rozwoju (np. Flutter + CMS). Najpierw stabilizujemy aplikację, potem dokładamy nowe funkcje.",
  },
  {
    q: "Flutter czy aplikacja natywna?",
    a: "Flutter sprawdza się, gdy chcesz jeden zespół i jeden codebase na Android i iOS przy rozsądnym budżecie. Natywnie wybieramy, gdy krytyczne są maksymalna wydajność, głęboka integracja z systemem albo bardzo specjalistyczne API platformowe.",
  },
  {
    q: "Czy robicie aplikacje Flutter do urządzeń BLE?",
    a: "Tak — to osobny tor produktowy. Jeśli potrzebujesz aplikacji do urządzenia Bluetooth Low Energy, zobacz stronę aplikacji BLE. Ta strona dotyczy Fluttera jako stacku mobilnego bez (lub niezależnie od) hardware.",
  },
  {
    q: "Czy Flutter obejmuje też backend i panel administracyjny?",
    a: "Aplikacja mobilna rzadko działa sama. Budujemy Flutter razem z API, panelem admina i CMS — albo podłączamy się do Waszego istniejącego backendu. Często zakres obejmuje Flutter + CMS / Node / AWS jako jeden projekt.",
  },
  {
    q: "Czy można podpisać NDA przed wyceną lub audytem?",
    a: "Tak. NDA przed przeglądem kodu albo rozmową o szczegółach produktu to standard — szczególnie przy przejęciu istniejącej aplikacji Flutter.",
  },
  {
    q: "Jak wygląda utrzymanie aplikacji Flutter po wdrożeniu?",
    a: "Oferujemy model godzinowy lub SLA: aktualizacje SDK, poprawki store, monitoring crashy, rozwój funkcji. Wiele firm przychodzi właśnie po utrzymanie i rozwój po MVP albo po odejściu poprzedniego dostawcy.",
  },
] as const;
